const NAME = "DIVISIONS_SETTINGS";

export default NAME;
